import { render, staticRenderFns } from "./CommunicationAdd.vue?vue&type=template&id=443c373e"
import script from "./CommunicationAdd.vue?vue&type=script&lang=js"
export * from "./CommunicationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports